import { Grid } from "@mui/material";
import React from "react";
import Header from "../../Layout/Header";
import FiltersHeader from "../../shared/FiltersHeader";

const SwiftMessages = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Header headLine="Swift Messages" action="export" />
        </Grid>
        <Grid item xs={12}>
          <FiltersHeader />
        </Grid>
      </Grid>
    </>
  );
};

export default SwiftMessages;
